<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="dashboard-sections">
	<mat-tab-group
		(selectedTabChange)="handleTabChanged($event)"
		[(selectedIndex)]="selectedTabIndex"
	>
		@for (tab of tabs; track tab.label) {
			<mat-tab [label]="tab.label" />
		}
	</mat-tab-group>

	<div class="tab-content">
		<router-outlet />
	</div>
</div>
